import React, { useState } from 'react';
import styled from 'styled-components';

const ButtonGroup = ({
  configs = []
}) => {
  const [activeBtn, setActiveBtn] = useState(configs[0]);

  const onClick = (button) => {
    setActiveBtn(button);
    button.onClick();
  }

  return (
    <Container>
      {configs && configs.map((button, i) => {
        return (
          <Button 
            key={button.title}
            isActive={button.title === activeBtn.title}
            isFirst={i === 0} 
            isLast={i === configs.length - 1}
            onClick={() => onClick(button)}>
            {button.title}
          </Button>
        )
      })}
    </Container>
  );
};

export default ButtonGroup;

const getBorderWidth = (isFirst, isLast) => {
  if(isFirst) {
    return "1px";
  } else if(isLast) {
    return "1px";
  } else {
    return "1px 0px 1px 0px";
  }
}

const getBorderRadius = (isFirst, isLast) => {
  if(isFirst) {
    return "3px 0px 0px 3px";
  } else if(isLast) {
    return "0px 3px 3px 0px";
  } else {
    return "0px";
  }
}

const getBackgroundColor = (isActive) => {
  if(isActive) return "#0F62FE";
  return "#fff"
}

const getColor = (isActive) => {
  if(isActive) return "#fff";
  return "#0F62FE";
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Button = styled.div`
  height: 100%;
  width: 100%;
  padding: 7px 12px; 
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: #0F62FE;
  border-style: solid;
  border-width: ${props => getBorderWidth(props.isFirst, props.isLast)};
  background-color: ${props => getBackgroundColor(props.isActive)};
  border-radius: ${props => getBorderRadius(props.isFirst, props.isLast)};
  color: ${props => getColor(props.isActive)};
  cursor: pointer;
  transition: all .3s;

  &:hover {
    background-color: #0152ea;
    color: #fff;
  }
`